import { render, staticRenderFns } from "./disbursement.vue?vue&type=template&id=ee6d1796&"
import script from "./disbursement.vue?vue&type=script&lang=js&"
export * from "./disbursement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports